<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Comision Medicos</span>
        </v-col>
        <!-- <v-col cols="2" class="pt-1">
                    <v-btn v-if="this.$hasPermision('marcas.create')" dark color="#023145" width="140" class="float-right" @click="handleShowCreate">
                        Nuevo
                    </v-btn>
                </v-col> -->
        <v-btn
          dark
          color="green"
          class="float-right mr-2"
          :loading="is_download"
          @click="handleDirectDownload"
        >
          <v-icon class="mr-1" size="16">fas fa-download</v-icon>
          Descargar
        </v-btn>
      </v-row>
      <v-row cols="10">
        <!-- <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_brand"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col> -->
        <!-- <v-col cols="1" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col> -->

        <v-col
          cols="11"
          class="pt-1"
          v-if="activeCalculate"
          style="display: flex; align-items: center;"
        >
          <!-- start medico -->
          <v-col cols="3" class="pb-3" v-if="filters.doctor == null">
            <v-autocomplete
              :value="filters.doctor_id"
              :items="doctorsList"
              label="Médico"
              hide-details
              outlined
              :item-text="customTextDoctor"
              item-value="id"
              clearable
              @change="handleSelectDoctor"
              :filters="customFilter"
              v-on:keyup.enter="searchDoctors($event)"
              :loading="isLoadingDoctors"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{
                    data.item.fullname
                  }}</v-list-item-title>
                  <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="3" class="pt-0 pb-0" v-if="filters.doctor">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                            text-uppercase
                            font-weight-bold
                            cart-label-customer
                          "
                      >{{ filters.doctor.fullname }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="ml-8">DNI: {{ filters.doctor.document }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearDoctor" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <!-- end medico -->

          <!-- start sucursal -->
          <v-col cols="2" class="pb-3" v-if="filters.office == null">
            <v-autocomplete
              :value="filters.office_id"
              :items="officesAux"
              label="Sucursal"
              hide-details
              outlined
              :item-text="customTextSucursal"
              item-value="id"
              clearable
              @change="handleSelectOffice"
              :filters="customFilter"
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                  <!-- <v-list-item-subtitle>
                    DNI: {{ data.item.document }}
                  </v-list-item-subtitle> -->
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="2" class="pt-0 pb-0" v-if="filters.office">
            <v-list two-line class="pt-0 pb-0">
              <v-list-item class="pl-1 pr-1">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon color="green" class="mr-2" size="18">
                      fas fa-user-tag
                    </v-icon>
                    <span
                      class="
                            text-uppercase
                            font-weight-bold
                            cart-label-customer
                          "
                      >{{ filters.office.name }}</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <!-- <span class="ml-8">DNI: {{ filters.office.document }}</span> -->
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="handleClearOffice" color="red">
                    <v-icon>far fa-times-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
          <!-- end sucursal -->

          <v-col cols="3" style="display: flex;">
            <label
              style="
                      font-size: 1.3rem;
                      margin-right: 0.4rem;
                      font-weight: bold;
                    "
              >Desde:</label
            >
            <v-menu
              v-model="menuDateInvoice_from"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="order_date"
                  :value="filters.date_invoice_from"
                  label="Fecha"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                  @change="set_date_invoice_from"
                ></v-text-field>
              </template>
              <v-date-picker
                :value="filters.date_invoice_from"
                @input="menuDateInvoice_from = false"
                no-title
                locale="es"
                @change="set_date_invoice_from"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" style="display: flex;">
            <label
              style="
                      font-size: 1.3rem;
                      margin-right: 0.4rem;
                      font-weight: bold;
                    "
              >Hasta:</label
            >
            <v-menu
              v-model="menuDateInvoice_until"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="order_date"
                  :value="filters.date_invoice_until"
                  label="Fecha"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                  @change="set_date_invoice_until"
                ></v-text-field>
              </template>
              <v-date-picker
                :value="filters.date_invoice_until"
                @input="menuDateInvoice_until = false"
                no-title
                locale="es"
                @change="set_date_invoice_until"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="3">
            <label
              style="
                    font-size: 1.5rem;
                    margin-right: 0.4rem;
                    font-weight: bold;
                    color: green;
                  "
              >Total:</label
            >
            <label style="font-size: 1.5rem; margin-right: 0.4rem"
              >S/ {{ total }}</label
            >
          </v-col>
        </v-col>
        <!-- <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('marcas.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col> -->
        <!-- <v-btn
          dark
          color="green"
          class="float-right mr-2"
          @click="handleDownload"
        >
          <v-icon class="mr-1" size="16">fas fa-download</v-icon>
          Descargar
        </v-btn> -->
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="comisiones"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
            >
              <template v-slot:top>
                <span
                  class="
                    ml-3
                    pt-3
                    pb-3
                    subtitle-1
                    font-weight-bold
                    w-title-table
                  "
                >
                  Todas las comisiones
                </span>
                <v-divider></v-divider>
              </template>

              <!-- <template v-slot:item.price="{ item }">
                <span>
                  {{ (item.percent * item.total) / 100 }}
                </span>
              </template> -->

              <template v-slot:item.name="{ item }">
                <span class="font-weight-medium">{{ item.name }}</span>
                <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
              </template>
              <!-- <template v-slot:item.status="{ item }">
                <span
                  v-if="item.status == 'PAGADO'"
                  style="
                    color: #00c706;
                    display: flex;
                    border: 2px solid;
                    padding: 0 5px;
                    width: max-content;
                    border-radius: 5px;
                  "
                >
                  {{ item.status }}
                </span>
                <span
                  v-if="item.status == 'PENDIENTE'"
                  style="
                    color: #f44336;
                    display: flex;
                    border: 2px solid;
                    padding: 0 5px;
                    width: max-content;
                    border-radius: 5px;
                  "
                >
                  {{ item.status }}
                </span>
              </template>
              -->
              <template v-slot:item.total="{ item }">
                <span> S/. {{ item.total }} </span>
              </template>
              <template v-slot:item.porcentaje="{ item }">
                <span v-if="item.direct"> -- </span>
                <span v-else> % {{ item.amount }} </span>
              </template>
              <template v-slot:item.soles="{ item }">
                <span v-if="item.direct"> S/ {{ item.amount }} </span>
                <span v-else>-- </span>
              </template>

              <template v-slot:item.order_code="{ item }">
                <!-- SUB TOTAL -->
                <span v-if="item.direct">
                  S/ {{ (item.total / 1.18).toFixed(2) }}
                </span>
                <span v-else
                  >S/
                  {{ (item.total / 1.18).toFixed(2) }}
                </span>
              </template>

              <template v-slot:item.sale_id="{ item }">
                <!-- IGV -->
                <span v-if="item.direct">
                  S/ {{ ((item.total / 0.18) * 0.18).toFixed(2) }}
                </span>
                <span v-else
                  >S/
                  {{ ((item.total / 1.18) * 0.18).toFixed(2) }}
                </span>
              </template>

              <template v-slot:item.price="{ item }">
                <!-- <span> S/. {{ item.amount }} </span> -->
                <span v-if="item.direct"> S/ {{ item.amount }} </span>
                <span v-else>
                  S/
                  {{ ((item.amount / 100) * (item.total / 1.18)).toFixed(2) }}
                </span>
              </template>

              <template v-slot:item.totalAux="{ item }">
                <span v-if="item.status == 'PAGADO'">
                  <span v-if="item.direct"> S/ {{ item.amount }} </span>
                  <span v-else>
                    S/ {{ (item.amount / 100) * item.total }}
                  </span>
                </span>
                <span v-if="item.status == 'PENDIENTE'"> S/ 0.00 </span>
              </template>

              <!-- status -->
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <!-- <v-btn v-if="this.$hasPermision('marcas.edit')" class="mt-3" dark color="blue" outlined @click="handleEdit">
                            <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
                            Editar
                        </v-btn>
                        <v-btn v-if="show_btn_active && this.$hasPermision('marcas.change_status')" class="ml-4 mt-3" dark color="green" outlined @click="handleChangeStatus">
                            <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
                            Activar
                        </v-btn>
                        <v-btn v-if="!show_btn_active && this.$hasPermision('marcas.change_status')" class="ml-4 mt-3" dark color="amber" outlined @click="handleChangeStatus">
                            <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
                            Inactivar
                        </v-btn>
                        <v-btn v-if="this.$hasPermision('marcas.destroy')" class="ml-4 mt-3" dark color="red" outlined @click="handleDelete">
                            <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
                            Eliminar
                        </v-btn> -->
            <v-btn
              v-if="
                show_btn_active && this.$hasPermision('marcas.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangePagar"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Pagar
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <create-update ref="createUpdate"></create-update>
    <Filters ref="filters"></Filters>
    <form-download ref="formDownload"></form-download>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/comision-medico/CreateUpdate";
import Filters from "../../../components/comision-medico/Filters";
import FormDownload from "../../../components/comision-medico/FormDownload";
import DoctorsApi from "../../../apis/Doctors";

export default {
  name: "ComisionMedicos",
  components: {
    CreateUpdate,
    Filters,
    OfficeLogin,
    FormDownload,
  },
  data() {
    return {
      search_brand: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      officesAux: [],
      statusRow: null,
      itemsBreadcrumbs: [
        {
          text: "Registros",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "MEDICO", value: "doctor_fullname" },
        { text: "FECHA", value: "register_date" },
        // { text: "ESTADO", value: "status" },
        { text: "VENTA", value: "total" },
        { text: "PORCENTAJE", value: "porcentaje" },
        { text: "SOLES", value: "soles" },
        { text: "SUB TOTAL", value: "order_code" },
        { text: "IGV", value: "sale_id" },
        { text: "A PAGAR", value: "price" },
        // { text: "PAGO", value: "totalAux" },
      ],
      activeCalculate: true,
      date_invoice_from: null,
      date_invoice_until: null,
      menuDateInvoice_from: false,
      menuDateInvoice_until: false,
      filters: {
        doctor: null,
        date_invoice_from: null,
        date_invoice_until: null,
        doctor_id: null,
        office: null,
        office_id: null,
      },
      total: 0,
      is_download: false,
      isLoadingDoctors: false,
      doctorsList: [],
    };
  },
  computed: {
    ...mapState("comisiones", ["comisiones"]),
    ...mapState("doctors", ["doctors"]),
    ...mapState("offices", ["offices"]),
  },
  methods: {
    ...mapActions("comisiones", [
      "getComisiones",
      "change_status",
      "delete",
      "change_pagar",
      "getExcelForComissions",
    ]),
    ...mapActions("doctors", ["getDoctors"]),
    ...mapActions("offices", ["getOffices"]),
    customTextDoctor(item) {
      let text = item.fullname;
      return text;
    },
    customTextSucursal(item) {
      let text = item.name;
      return text;
    },
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nueva Comision", "create");
    },
    handleEdit() {
      let select = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de Comision",
        "update",
        select
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de Comision Medicos");
    },
    async getAllCommissions() {
      await this.getComisiones();
      this.getComissionsFilter();
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        fullname: this.search_brand,
      };
      await this.getComisiones(filters);
    },
    async handleChangeStatus() {
      let comision = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(comision);
    },
    async handleDelete() {
      let comision = this.selectedRows[0];
      await this.delete(comision);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    async handleChangePagar() {
      // let comision = this.selectedRows[0]
      // this.selectedRows = []
      // this.showOptionCrud()
      // await this.change_pagar(comision)

      let select = this.selectedRows[0];
      if (select.status == "PENDIENTE") {
        this.selectedRows = [];
        this.showOptionCrud();
        this.$refs.createUpdate.showForm(
          "Modificar datos de Comision",
          "update",
          select
        );
      }
    },
    async set_date_invoice_until(value) {
      // console.log(this.filters.date_invoice_until);
      this.filters.date_invoice_until = value;
      // if (this.filters.date_invoice_until && this.filters.date_invoice_from)
      //   this.getComissionsFilter();
      this.getComissionsFilter();
    },
    async set_date_invoice_from(value) {
      // console.log(this.filters.date_invoice_from);
      this.filters.date_invoice_from = value;
      // if (this.filters.date_invoice_until && this.filters.date_invoice_from)
      //   this.getComissionsFilter();
      this.getComissionsFilter();
    },
    customFilter(item, queryText, itemText) {
      let textName = "";
      if (item.name) {
        if (item.fullname) {
          textName = item.fullname.toLowerCase();
        } else {
          textName = item.name.toLowerCase();
        }
      }
      let textDocument = "";
      if (item.document) {
        textDocument = item.document.toLowerCase();
      }
      let searchText = queryText.toLowerCase();
      return (
        textName.indexOf(searchText) > -1 ||
        textDocument.indexOf(searchText) > -1
      );
    },
    async handleSelectDoctor(value) {
      if (value == null || value == undefined) {
        this.filters.doctor = null;
      } else {
        let selected_doctor = ArrayTools.getElementById(
          this.doctorsList,
          value
        );
        this.filters.doctor = selected_doctor;
        this.filters.doctor_id = selected_doctor.id;
      }
      // if (this.filters.doctor_id) this.getComissionsFilter();
      this.getComissionsFilter();
    },
    async handleClearDoctor() {
      this.filters.doctor = null;
      this.filters.doctor_id = null;
      this.getComissionsFilter();
    },
    async handleSelectOffice(value) {
      if (value == null || value == undefined) {
        this.filters.office = null;
      } else {
        let selected_office = ArrayTools.getElementById(this.officesAux, value);
        this.filters.office = selected_office;
        this.filters.office_id = selected_office.id;
      }
      // if (this.filters.office_id)
      this.getComissionsFilter();
    },
    handleClearOffice() {
      this.filters.office = null;
      this.filters.office_id = null;
      this.getComissionsFilter();
    },
    async getComissionsFilter() {
      await this.getComisiones({
        ...this.filters,
        doctor: null,
        office: null,
      });
      let sumTotal = 0;
      this.comisiones.map((item) => {
        const total = item.direct
          ? item.amount
          : (item.amount / 100) * item.total;
        sumTotal = sumTotal + parseInt(total);
      });
      this.total = sumTotal;

      // if (this.filters.office_id && this.filters.doctor_id) {
      //   let sumTotal = 0;
      //   this.comisiones.map((item) => {
      //     const total = item.direct
      //       ? item.amount
      //       : (item.amount / 100) * item.total;
      //     sumTotal = sumTotal + parseInt(total);
      //   });
      //   this.total = sumTotal;
      // } else {
      //   this.total = 0;
      // }
    },
    handleDownload() {
      this.$refs.formDownload.showForm({
        ...this.filters,
        doctor: null,
        office: null,
      });
    },
    async handleDirectDownload() {
      this.is_download = true;
      // this.emptyFi leSales();
      // let filters_data = Object.assign({}, this.filters);
      // filters_data.company_id = this.company_id;
      const response = await this.getExcelForComissions({
        ...this.filters,
        doctor: null,
        office: null,
      });
      this.is_download = false;
      // console.log(response);
      if (response.file_excel) {
        let url = process.env.VUE_APP_API_URL_BASE + "/" + response.file_excel;
        window.open(url);
      }
      // if (this.file_sales) {
      // }
    },
    async searchDoctors(value) {
      let filters = {};

      if (value?.target.value.length > 0)
        filters = { fullname: value.target.value };
      this.isLoadingDoctors = true;
      const response = await DoctorsApi.get_allPaginated(filters);
      if (response.status == 200) {
        this.doctorsList = response.data.data;
      }

      this.isLoadingDoctors = false;
    },
    async loadData() {
      await this.getOffices();
      this.officesAux = [];
      this.offices.map((dt) => {
        this.officesAux.push(dt);
        // console.log(dt);
      });
      this.officesAux.push({ id: -1, name: "TODOS" });
    },
  },
  created() {
    this.getAllCommissions();
    // this.getDoctors();
    this.searchDoctors();
    this.loadData();
  },
};
</script>

<style scoped></style>
